(() => {
  'use strict';
  if (window.__yyCartAnalyticsLoaded) return;
  window.__yyCartAnalyticsLoaded = true;

  const once = new Set();

  const transportMode = () => {
    if (window.google_tag_manager && Object.keys(window.google_tag_manager).length) return 'gtm';
    if (typeof window.gtag === 'function') return 'gtag';
    return 'queued';
  };

  const contextFor = source => {
    const selector = source === 'drawer'
      ? '.m-cart-drawer .yy-cart-analytics-context'
      : '.yy-full-cart .yy-cart-analytics-context';
    const el = document.querySelector(selector);
    return {
      source,
      value: Number(el?.dataset.yyCartTotal || 0) / 100,
      item_count: Number(el?.dataset.yyCartCount || 0),
      currency: el?.dataset.yyCurrency || 'INR'
    };
  };

  const sendGa = (event, params) => {
    const mode = transportMode();
    if (mode === 'gtag' && typeof window.gtag === 'function') {
      try { window.gtag('event', event, params); } catch(e) {}
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params, yy_ga4_mapped:true });
  };

  const push = (event, params={}) => {
    const payload = {
      event,
      yy_event_version:'1.0',
      yy_timestamp:new Date().toISOString(),
      yy_transport:transportMode(),
      ...params
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('yy:analytics',{detail:payload}));
  };

  const view = source => {
    const ctx=contextFor(source);
    const key='view:'+source+':'+ctx.item_count+':'+ctx.value;
    if(once.has(key) || !ctx.item_count) return;
    once.add(key);
    push('yy_cart_view',ctx);
    sendGa('view_cart',{
      currency:ctx.currency,
      value:ctx.value,
      yy_source:source,
      yy_item_count:ctx.item_count
    });
  };

  if(document.body.classList.contains('template-cart')){
    requestAnimationFrame(()=>view('cart_page'));
  }

  const drawer=document.getElementById('MinimogCartDrawer');
  if(drawer && 'MutationObserver' in window){
    let wasOpen=drawer.classList.contains('m-cart-drawer--active');
    const observer=new MutationObserver(()=>{
      const open=drawer.classList.contains('m-cart-drawer--active');
      if(open && !wasOpen){
        once.delete([...once].find(k=>k.startsWith('view:drawer:'))||'');
        view('drawer');
      }
      wasOpen=open;
    });
    observer.observe(drawer,{attributes:true,attributeFilter:['class']});
  }

  document.addEventListener('click',event=>{
    const checkout=event.target.closest?.('button[name="checkout"], input[name="checkout"]');
    if(checkout){
      const source=checkout.dataset.yyCheckoutSource || (checkout.closest('m-cart-drawer')?'drawer':'cart_page');
      const value=Number(checkout.dataset.yyCartTotal || 0)/100;
      const currency=checkout.dataset.yyCurrency || 'INR';
      push('yy_cart_checkout_click',{source,value,currency});
      sendGa('begin_checkout',{currency,value,yy_source:source});
      return;
    }

    const bundle=event.target.closest?.('[data-yy-bundle-add]');
    if(bundle){
      push('yy_cart_cross_sell_add',{
        source:bundle.closest('m-cart-drawer')?'drawer':'cart_page'
      });
      return;
    }

    const coupon=event.target.closest?.('[data-action="coupon"]');
    if(coupon){
      push('yy_cart_coupon_interaction',{
        source:coupon.closest('m-cart-drawer')?'drawer':'cart_page',
        action:coupon.classList.contains('m-cart-addon--save')?'apply':'open_or_close'
      });
    }
  },true);

  document.addEventListener('yy:cart-discount',event=>{
    const d=event.detail||{};
    push('yy_cart_discount_result',{
      source:d.source||'unknown',
      status:d.status||'unknown',
      has_code:!!d.hasCode
    });
  });

  document.addEventListener('cart:updated',()=>{
    setTimeout(()=>{
      if(document.body.classList.contains('template-cart')) view('cart_page');
      if(drawer?.classList.contains('m-cart-drawer--active')) view('drawer');
    },250);
  });

  window.YYCartAnalytics=Object.freeze({track:push,transport:transportMode,context:contextFor});
})();